type Tab<T extends string> = { id: T; label: string; alert?: boolean };

export function AudienceDataModeSlider<T extends string>(props: {
  value: T;
  onChange: (value: T) => void;
  ariaLabel: string;
  tabs: ReadonlyArray<Tab<T>>;
}) {
  return (
    <div
      role="tablist"
      aria-label={props.ariaLabel}
      className="flex max-w-full flex-nowrap overflow-x-auto rounded-lg bg-gray-100 p-0.5 text-sm dark:bg-zinc-900"
    >
      {props.tabs.map((tab) => {
        const on = props.value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={on}
            className={
              "shrink-0 whitespace-nowrap rounded-md px-3 py-1 text-sm font-semibold transition-colors " +
              (on
                ? "bg-white text-gray-900 shadow-sm dark:bg-zinc-950 dark:text-zinc-100"
                : tab.alert
                  ? "text-amber-800 hover:text-amber-950 dark:text-amber-300 dark:hover:text-amber-200"
                  : "text-gray-600 hover:text-gray-900 dark:text-zinc-400 dark:hover:text-zinc-200")
            }
            onClick={() => props.onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
